"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Error = _interopRequireDefault(require("../Error"));

var _Label = require("../Label/Label");

var _Typography = require("../../Typography");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 0;\n  margin-left: 4px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  cursor: default;\n  padding: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// Based on current designs, legend and error text should look the same as label text
var Element = _styledComponents.default.legend(_templateObject(), _Label.labelStyles);

var Error = (0, _styledComponents.default)(_Error.default)(_templateObject2());

var Legend = function Legend(_ref) {
  var errorText = _ref.errorText,
      children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, ["errorText", "children"]);
  return children ? /*#__PURE__*/_react.default.createElement(Element, props, /*#__PURE__*/_react.default.createElement(_Typography.Typography.SmallBodyBold, {
    as: "span"
  }, children), /*#__PURE__*/_react.default.createElement(Error, null, errorText)) : null;
};

Legend.propTypes = {
  /** The node that should be rendered */
  children: _propTypes.default.node.isRequired,

  /** The text of an error within a form */
  errorText: _propTypes.default.string
};
Legend.defaultProps = {
  errorText: ''
};
var _default = Legend;
exports.default = _default;